import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // must import the Tailwind-enabled CSS
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
